module.exports = __webpack_public_path__ + "b27c1a674a6bba01c98ec4914d72c62b.MP3";